<template>
  <div class="animation-wrapper">
    <SceneAnimationComponent
      :name="animation.name"
      :fullScreen="animation.fullScreen"
      :key="animation.name"
      v-for="animation in loadedSceneAnimations"
      :ref="(el) => setRef(el, animation.name)"
      @animation-finished="animationFinished"
    />
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
// Components
import SceneAnimationComponent from '@/components/SceneAnimationComponent.vue'

// Stores
import { useEffectsStore } from '@/stores/EffectsStore'

// Services
import Logger from '@/services/Logger'

const logger = new Logger('Scene', true)

const effectsStore = useEffectsStore()
const { loadedSceneAnimations, sceneAnimationState } = storeToRefs(effectsStore)
const animationRefs = ref({})

// NOTE: Watchers
watch(sceneAnimationState, (newVal) => {
  if (newVal) playAnimation(newVal)
})

// NOTE: Methods
const setRef = (el, index) => {
  animationRefs.value[index] = el
}

const playAnimation = (animationName) => {
  if (animationName) {
    const refInstance = animationRefs.value[animationName]
    if (refInstance) {
      logger.log('playing scene animation', animationName)
      effectsStore.setSceneAnimationPlaying(true)
      refInstance.play()
    }
  }
}

const animationFinished = () => {
  logger.log('scene animation finished')
  effectsStore.setSceneAnimationPlaying(false)
  effectsStore.setSceneAnimationState(null)
}
</script>
<style scoped>
.animation-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  height: var(--full-vh);
  width: var(--full-vw);
  max-width: var(--full-vw);
  max-height: var(--full-vh);
  overflow-y: hidden;
  z-index: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}
</style>
